import { Link } from 'react-router-dom';
import heroImage from '@/assets/granary_heroheader.jpeg';
import styles from './HomePage.module.css';

function HomePage() {
  return (
    <div className={styles.page}>
      <section className={styles.hero} style={{ backgroundImage: `url(${heroImage})` }}>
        <h1 className={styles.heroTitle}>
          The only pub in the world where you can drink a cold Sam Adams&apos; while viewing a cold Sam Adams
        </h1>
      </section>

      <section className={styles.hoursSection}>
        <h1 className={styles.hoursHeading}>Billiards, Cocktails, Beer, And Fine Pub Dining</h1>
        <h5 className={styles.hoursSubtitle}>Serving the heart of historic downtown Boston</h5>
        <h2 className={styles.hoursLabel}>Open Daily</h2>
        <h3 className={styles.hoursTime}>9:00 AM to 2:00 AM</h3>
        <h2 className={styles.hoursLabel}>Serving Food Late Night</h2>
        <h2 className={styles.hoursLabel}><Link to="/menu">See menu &#10148;</Link></h2>
        <h2 className={styles.hoursLabel}>Looking for takeout?</h2>
        <a
          href="https://www.grubhub.com/restaurant/beantown-pub-100-tremont-st-boston/2287522"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.grubhubLink}
        >
          Order From GrubHub
        </a>
      </section>

      <section className={styles.giftSection}>
        <h3 className={styles.giftHeading}>Gift Cards and Merchandise Available</h3>
        <h4 className={styles.giftText}>
          Make your next private event a memorable one and book it at Beantown
          <br />
          <Link to="/parties" className={styles.giftLink}>Learn more &#10148;</Link>
        </h4>
      </section>

      <section className={styles.faqSection}>
        <h3 className={styles.faqHeading}>Want more info?</h3>
        <h2 className={styles.faqText}>See our frequently asked questions</h2>
        <h2><Link to="/about" className={styles.faqLink}>FAQ &#10148;</Link></h2>
      </section>
    </div>
  );
}

export default HomePage;
